<template>
  <header class="header">
    <h1 class="header__title">{{ getWords("header_title") }}</h1>
    <div class="right_side">
      <a v-if="checkLogoutName" class="header__logout" @click="$emit('logout')">{{ getWords("header_logout") }}</a>
      <div class="divider"></div>
      <select name="language" id="language" class="select" v-model="sLanguage" @change="languageSelected">
        <option value="ja">{{ getWords("header_language_ja") }}</option>
        <!-- <option value="kr">{{ getWords("header_language_kr") }}</option> -->
        <option value="en">{{ getWords("header_language_en") }}</option>
      </select>
      <!-- <div class="divider"></div>
      <select name="score" id="score" class="select" v-model="sScore" @change="scoreSelected">
        <option value="age">{{ getWords("header_score_age") }}</option>
        <option value="point">{{ getWords("header_score_point") }}</option>
      </select> -->
    </div>
  </header>
</template>

<script>
import words from '../assets/localewords.json'
import { SU, SessionKey } from '../utils/session_utils'
export default {
  name: 'MedicalHeaderItem',
  data: () => ({
    sLanguage: 'ja',
    sScore: 'age'
  }),
  computed: {
    checkLogoutName: function () {
      if (typeof this.$route.name === 'undefined' || this.$route.name === null) {
        return false
      }
      if (this.$route.name === 'member_login') {
        return false
      }
      return true
    },
    getLanguage () {
      return this.$store.state.language
    },
    getScoreType () {
      return this.$store.state.score
    }
  },
  created () {
    const lang = this.getLanguage
    if (lang === 'ja' || lang === 'en' || lang === 'kr') {
      this.sLanguage = lang
    } else {
      this.sLanguage = 'ja'
      this.updateStorageLanguage(this.sLanguage)
    }
    const score = this.getScoreType
    if (score === 'age' || score === 'point') {
      this.sScore = score
    } else {
      this.sScore = 'age'
      this.updateStorageScore(this.sScore)
    }
  },
  methods: {
    getWords (key) {
      let lang = this.getLanguage
      const word = words[key] ? words[key][lang] : ''
      return word
    },
    updateStorageLanguage: function (lang) {
      let v = lang
      if (lang !== 'ja' && lang !== 'en' && lang !== 'kr') {
        v = 'ja'
      }
      SU.saveSession(SessionKey.language, v)
      this.$store.dispatch('commitLanguage', v)
    },
    languageSelected: function () {
      this.updateStorageLanguage(this.sLanguage)
    },
    updateStorageScore: function (lang) {
      let v = lang
      if (lang !== 'age' && lang !== 'point') {
        v = 'age'
      }
      SU.saveSession(SessionKey.score, v)
      this.$store.dispatch('commitScore', v)
    },
    scoreSelected: function () {
      this.updateStorageScore(this.sScore)
    }
  }
}
</script>

<style scoped lang="scss">
@use "../assets/scss/style" as g;
.header {
  @include g.flex;
  @include g.flex_justify('between');
  @include g.flex_align('center');
  padding: 1.1rem 1.8rem 1.2rem;
  background: g.$black;
  @include g.mediaMobile {
    padding: 0.6rem;
  }
  @include g.mediaMobile {
    padding: 0.6rem;
  }
  &__title {
    display: inline-block;
    font-size: 2rem;
    color: #FFF;
    vertical-align: middle;
    @include g.mediaMobile {
      font-size: 1.4rem;
    }
  }
  .right_side {
    display: flex;
  }
  &__logout {
    display: block;
    font-size: 1.8rem;
    line-height: 40px;
    color: #FFF;
    cursor: pointer;
    @include g.mediaMobile {
      font-size: 1.4rem;
    }
  }
  .select {
    padding: 0 0.5rem;
    font-size: 1.8rem;
    color: #FFF;
    background: g.$black;
    -webkit-border-radius: .4rem;
    -moz-border-radius: .4rem;
    border-radius: .4rem;
    border: none;
    @include g.mediaMobile {
      font-size: 1.4rem;
    }
  }
  .divider {
    margin: 0 1rem;
    width: 1px;
    background: #FFF;
  }
}
</style>
